/* eslint-disable default-param-last */
import * as types from './types';

const initialState = {
  transactions: [],
  isLoading: false,
};
export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_IS_LOADING:
    case types.SET_TRANSACTIONS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
